import {
  GraphQLObjectType,
  GraphQLString,
  GraphQLNonNull,
  GraphQLID,
  GraphQLBoolean
} from 'graphql';

import UserType from './user.gql.js';

const notificationType = new GraphQLObjectType({
  name: 'Notification',
  fields: () => ({
    id: {
      type: new GraphQLNonNull(GraphQLID),
      resolve: item => item.id
    },
    pid: {
      type: GraphQLString,
      resolve: item => item.pid
    },
    read: {
      type: GraphQLBoolean,
      resolve: item => item.read
    },
    user: {
      type: UserType,
      resolve: item => item.user
    },
    timeStamp: {
      type: GraphQLString,
      resolve: item => item.timeStamp
    },
    type: {
      type: GraphQLString,
      resolve: item => item.type
    },
    message: {
      type: GraphQLString,
      resolve: item => item.message
    }
  })
});

window[notificationType.name + 'GQLType'] = notificationType;

export default notificationType;
